/* global profitwell */
const Raven = require('lib/raven')
const log = require('log').create('profitwell') // eslint-disable-line

// all stripe IDs begin with cus_
const stripe_id_regex = /^cus_/

const ProfitWell = {

    // moved this to a property so we can nullify it in tests
    url: 'https://dna8twue3dlxq.cloudfront.net/js/profitwell.js',

    auth_token: 'b60dfd87dcecb9ea1760f67d624a5851',

    initialize(options = {}) {
        /* eslint-disable */
        // ProfitWell JS snippet
        (function(i,s,o,g,r,a,m) {i['ProfitWellObject']=r;i[r]=i[r]||function() {
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script',this.url,'profitwell')
        /* eslint-enable */

        this.configure(options)
    },

    configure(options) {
        try {
            profitwell('auth_token', this.auth_token)

            const cust_id = this.getCustId(options.viewer)
            if (cust_id) {
                profitwell('user_id', cust_id)
                profitwell('cq_get')
            }
        } catch (e) {
            Raven.captureException(e)
        }
    },

    getCustId(viewer) {
        // get viewer's customer id
        const cust_id = (
            viewer
            && viewer.store
            && viewer.store.cust_id
        )
        if (stripe_id_regex.test(cust_id)) return cust_id
        return null
    },

}

module.exports = ProfitWell
